var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectionProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 88,
    viewBox: "0 0 103 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10,
    y: 7,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DF6438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.4143 41.8404C65.7459 40.1443 63.5292 39.2103 61.1728 39.2103C61.0696 39.2103 60.9668 39.2121 60.8642 39.2157C58.7089 39.2912 56.6974 40.2218 55.2005 41.8362C53.717 43.4361 52.9 45.5297 52.9 47.7315V57.151C52.9 58.046 52.7361 58.915 52.4121 59.7354C51.3682 62.3912 48.8766 64.1072 46.0644 64.1072C42.4761 64.1072 39.4978 61.2762 39.2468 57.6474C43.4217 57.1731 46.6231 53.5786 46.6231 49.2466V35.5972C46.6231 35.0745 46.2066 34.6508 45.6929 34.6508H44.1352V29.9464C44.1352 29.4237 43.7187 29 43.205 29H33.4177C32.904 29 32.4875 29.4237 32.4875 29.9464V34.6508H30.9302C30.4164 34.6508 30 35.0745 30 35.5972V49.2466C30 53.5895 33.2353 57.1775 37.3827 57.6488C37.383 57.6582 37.3824 57.6674 37.3829 57.6768C37.652 62.344 41.4653 66 46.0644 66C49.6418 66 52.8115 63.8169 54.1389 60.4397C54.5513 59.3953 54.7604 58.2889 54.7604 57.151V47.7315C54.7604 44.1981 57.5273 41.2265 60.9279 41.1074C61.0092 41.1046 61.0908 41.1031 61.1728 41.1031C63.0326 41.1031 64.7822 41.8405 66.0991 43.1791C67.415 44.5178 68.1396 46.2975 68.1396 48.1901V59.9389C68.1396 60.4615 68.5561 60.8853 69.0698 60.8853C69.5835 60.8853 70 60.4615 70 59.9389V48.1901C70 45.7919 69.0818 43.5369 67.4143 41.8404ZM34.3479 30.8928H42.2748V34.6507H34.3479V30.8928ZM31.8604 49.2466V36.5436H44.7627V49.2466C44.7627 52.743 42.0769 55.6217 38.6488 55.8004C38.537 55.8061 38.4235 55.8091 38.3115 55.8091C34.7543 55.8091 31.8604 52.8652 31.8604 49.2466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy",
    d: "M95.5 18C99.0899 18 102 15.0899 102 11.5C102 7.91015 99.0899 5 95.5 5C91.9101 5 89 7.91015 89 11.5C89 15.0899 91.9101 18 95.5 18Z",
    stroke: "#DF6438",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy_2",
    d: "M5.5 83C7.98528 83 10 80.9853 10 78.5C10 76.0147 7.98528 74 5.5 74C3.01472 74 1 76.0147 1 78.5C1 80.9853 3.01472 83 5.5 83Z",
    stroke: "#DF6438",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy_3",
    d: "M18.5 8C20.433 8 22 6.433 22 4.5C22 2.567 20.433 1 18.5 1C16.567 1 15 2.567 15 4.5C15 6.433 16.567 8 18.5 8Z",
    stroke: "#DF6438",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy_4",
    d: "M80 87C81.1046 87 82 86.1046 82 85C82 83.8954 81.1046 83 80 83C78.8954 83 78 83.8954 78 85C78 86.1046 78.8954 87 80 87Z",
    stroke: "#DF6438",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionProblem);
export default __webpack_public_path__ + "static/media/connection-problem.182d0feb80e0e30a75c07484b57f81e3.svg";
export { ForwardRef as ReactComponent };